module.exports = __webpack_public_path__ + "img/laptop-coding.5b0245ac.png";